import { gql } from '@apollo/client';
import type { SaveStationAbMappingsInput } from './saveStationAbMappings';

/**
 * 站点 AB 映射保存前的冲突预检（2.2 需求点2 · D2）。
 *
 * AB 唯一性要求同一维度只能指向一个实际上门 B 站点，所以保存时会把**其他站点**下的同维度映射置失效。
 * 这个动作原本完全静默 —— 运营在站点 X 加一条 A 地址，可能顺手把站点 Y 的映射干掉，
 * 而 Y 的运营毫不知情，只会某天发现「那批货怎么又跑回 A 了」。
 *
 * 入参与 `SAVE_STATION_AB_MAPPINGS` **完全相同**：两次调用之间前端不改内容，
 * 预检看到的和保存执行的就是同一批数据。
 *
 * 定义为 mutation 而非 query 是后端的刻意选择（见 PickupStationMaintainMutation 注释）：
 * 它要与 saveStationAbMappings 共用同一份地址标准化结果，拆到 Query 类会让这个不变式失去结构保障。
 * 副作用上它是只读的，前端可放心重复调用。
 */
export const PREVIEW_STATION_AB_MAPPING_CONFLICTS = gql`
  mutation PreviewStationAbMappingConflicts($input: SaveStationAbMappingsInput!) {
    previewStationAbMappingConflicts(input: $input) {
      abMappingId
      cooperationWarehouseId
      cooperationWarehouseName
      originAddressLine1
      originAddressLine2
      originCity
      originState
      originZipcode
      contactName
      contactPhone
      channelId
    }
  }
`;

/** 一条「将被失效」的映射。字段全可空：站点可能已被删、联系人可能本就没填。 */
export interface AbMappingConflict {
  abMappingId?: number | null;
  /** 会被影响的 B 站点 id */
  cooperationWarehouseId?: number | null;
  /** B 站点名称；查不到时为空，展示需按 id 兜底 */
  cooperationWarehouseName?: string | null;
  originAddressLine1?: string | null;
  originAddressLine2?: string | null;
  originCity?: string | null;
  originState?: string | null;
  originZipcode?: string | null;
  contactName?: string | null;
  contactPhone?: string | null;
  channelId?: number | null;
}

export interface PreviewStationAbMappingConflictsResponse {
  previewStationAbMappingConflicts: AbMappingConflict[];
}

export type PreviewStationAbMappingConflictsVariables = { input: SaveStationAbMappingsInput };
